/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  PutApiV1CoursefinancialCoursesCourseidPlansId200,
  PutApiV1CoursefinancialCoursesCourseidPlansId400,
  PutApiV1CoursefinancialCoursesCourseidPlansId401,
  PutApiV1CoursefinancialCoursesCourseidPlansId404,
  PutApiV1CoursefinancialCoursesCourseidPlansId500,
  PutApiV1CoursefinancialCoursesCourseidPlansIdMutationRequest,
  PutApiV1CoursefinancialCoursesCourseidPlansIdMutationResponse,
  PutApiV1CoursefinancialCoursesCourseidPlansIdPathParams,
} from "../../types/courseFinancialRegistrationController/PutApiV1CoursefinancialCoursesCourseidPlansId.ts";
import { courseFinancialDetailViewModelSchema } from "../courseFinancialDetailViewModelSchema.ts";
import { courseFinancialEditorViewModelSchema } from "../courseFinancialEditorViewModelSchema.ts";

export const putApiV1CoursefinancialCoursesCourseidPlansIdPathParamsSchema =
  z.object({
    courseId: z.coerce.number().int(),
    id: z.coerce.number().int(),
  }) as unknown as ToZod<PutApiV1CoursefinancialCoursesCourseidPlansIdPathParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const putApiV1CoursefinancialCoursesCourseidPlansId200Schema = z.lazy(
  () => courseFinancialDetailViewModelSchema,
) as unknown as ToZod<PutApiV1CoursefinancialCoursesCourseidPlansId200>;

/**
 * @description (Bad Request) Requisição em formato incorreto ou com dados faltantes.
 */
export const putApiV1CoursefinancialCoursesCourseidPlansId400Schema =
  z.any() as unknown as ToZod<PutApiV1CoursefinancialCoursesCourseidPlansId400>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const putApiV1CoursefinancialCoursesCourseidPlansId401Schema =
  z.any() as unknown as ToZod<PutApiV1CoursefinancialCoursesCourseidPlansId401>;

/**
 * @description (Not Found) Registro não encontrado.
 */
export const putApiV1CoursefinancialCoursesCourseidPlansId404Schema =
  z.any() as unknown as ToZod<PutApiV1CoursefinancialCoursesCourseidPlansId404>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const putApiV1CoursefinancialCoursesCourseidPlansId500Schema =
  z.any() as unknown as ToZod<PutApiV1CoursefinancialCoursesCourseidPlansId500>;

export const putApiV1CoursefinancialCoursesCourseidPlansIdMutationRequestSchema =
  z.lazy(
    () => courseFinancialEditorViewModelSchema,
  ) as unknown as ToZod<PutApiV1CoursefinancialCoursesCourseidPlansIdMutationRequest>;

export const putApiV1CoursefinancialCoursesCourseidPlansIdMutationResponseSchema =
  z.lazy(
    () => putApiV1CoursefinancialCoursesCourseidPlansId200Schema,
  ) as unknown as ToZod<PutApiV1CoursefinancialCoursesCourseidPlansIdMutationResponse>;
